module.exports = __webpack_public_path__ + "img/baseMaterial.e8090fba.png";